/**
 * @deprecated Import `HBCurrency` directly from `@honeybook/i18n-react` instead.
 * This module is kept for backward compatibility only.
 *
 * @example
 * // Before
 * import HBCurrency from '@honeybook/hbui/dist/components/HBCurrency/HBCurrency';
 *
 * // After
 * import { HBCurrency } from '@honeybook/i18n-react';
 */

// Re-export the canonical implementation from @honeybook/i18n-react.
export { HBCurrency as default } from '@honeybook/i18n-react';
export type { HBCurrencyProps } from '@honeybook/i18n-react';

// ICurrencyProps — deprecated alias kept for backward compatibility.
export type { HBCurrencyProps as ICurrencyProps } from '@honeybook/i18n-react';

// Currency union type — re-exported for consumers that imported it from this path.
export type { Currency } from '@honeybook/i18n-react';
